import React from "react"
import { ILeaderboardInfo } from "../../../../../types/interfaces/LeaderboardInfo"
import { useAppSelector } from "../../../hooks"
import Leaderboard from "./leaderboard"
import LeaderboardItem from "./leaderboard-item"

export default function PlayerLeaderboard() {
  const uid = useAppSelector((state) => state.network.uid)
  const profile = useAppSelector((state) => state.network.profile)
  const infos: ILeaderboardInfo[] = useAppSelector(
    (state) => state.lobby.leaderboard
  )

  const myEntry = infos.find((e) => e.id === uid)
  const pinnedEntry: ILeaderboardInfo | undefined =
    myEntry ??
    (profile
      ? {
          id: uid,
          name: profile.displayName,
          avatar: profile.avatar,
          rank: 0,
          value: profile.elo
        }
      : undefined)

  return (
    <div style={{ display: "flex", flexFlow: "column", gap: "4px" }}>
      {pinnedEntry && (
        <>
          <LeaderboardItem
            item={pinnedEntry}
            isBot={false}
            noElo={false}
            currentUid={uid}
          />
          <hr className="pinned-row-separator" />
        </>
      )}
      <Leaderboard isBot={false} infos={infos} noElo={false} currentUid={uid} />
    </div>
  )
}
